/** Banner frame owns a container so copy and icon follow banner width, not the viewport. */
export const FEATURED_BANNER_FRAME_CLASS =
  "featured-banner-frame relative w-full overflow-hidden rounded-3xl";

/**
 * Below this banner width (Tailwind `sm`), the icon is slightly smaller so the
 * description stays off the bottom edge. Description stays visible.
 */
export const FEATURED_BANNER_NARROW_BELOW_PX = 640;

export const FEATURED_BANNER_COPY_CLASS =
  "featured-banner-copy w-[35%] h-full px-2 text-white flex flex-col justify-center";

/** Frame hugs the mark; image max-height is 2/3 (52% below 640px) of the banner. */
export const FEATURED_BANNER_ICON_CLASS =
  "featured-banner-icon relative mx-auto mb-1 flex items-center justify-center";

export const FEATURED_BANNER_ICON_IMAGE_CLASS = "featured-banner-icon-image drop-shadow-lg";

export const FEATURED_BANNER_DESCRIPTION_CLASS =
  "featured-banner-description mx-auto line-clamp-2 leading-tight text-white text-center font-bold text-balance";
